import { CheckboxList, type CheckboxOption } from "@/components/cinch/FilterBar/CheckboxList";
import { FilterChip } from "@/components/cinch/FilterBar/FilterBar";
import { DateRangePicker, type DateRange } from "@/components/cinch/DatePicker";

/** Composed filter chips — promoted from contracts (2026-08-19): proposals was
 *  already importing them across the feature boundary, and integrations would
 *  have been the second cross-feature import. contracts/components/filters.tsx
 *  re-exports these, so existing import paths keep working. */

export function MultiSelectChip({
  label,
  options,
  value,
  onChange,
}: {
  label: string;
  options: CheckboxOption[];
  value: string[];
  onChange: (v: string[]) => void;
}) {
  return (
    <FilterChip label={label} count={value.length}>
      <CheckboxList
        options={options}
        selected={value}
        onChange={onChange}
        searchable={options.length > 8}
      />
    </FilterChip>
  );
}

function fmtLocal(d: Date | null): string {
  if (!d) return "…";
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function DateRangeChip({
  label,
  value,
  onChange,
}: {
  label: string;
  value: DateRange;
  onChange: (r: DateRange) => void;
}) {
  const valueLabel =
    value.start || value.end ? `${fmtLocal(value.start)} → ${fmtLocal(value.end)}` : undefined;
  return (
    <FilterChip label={label} valueLabel={valueLabel}>
      <div className="space-y-2">
        <DateRangePicker value={value} onChange={onChange} placeholder="Pick a range" />
        {(value.start || value.end) && (
          <button
            type="button"
            onClick={() => onChange({ start: null, end: null })}
            className="text-xs text-brand hover:underline focus-visible:outline-none focus-visible:underline"
          >
            Clear
          </button>
        )}
      </div>
    </FilterChip>
  );
}
